// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2-qiA","signatureButtonsRight":"ModalSign_signatureButtonsRight__2k8S1"};